import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5989dc4c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "content" }

import { useComputedValue } from "@/composables/useComputedValue";
import { useVisualViewport } from "@/composables/useVisualViewport";
import { GetterTypes } from "@/store";
import { LayoutBackgroundColorTypes } from "@/store/app/state";
import { ref } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'MobileLayout',
  setup(__props) {

const root = ref<HTMLElement>();
const { style } = useVisualViewport(root);

const backgroundColorTypeTop = useComputedValue<LayoutBackgroundColorTypes>(
  GetterTypes.GET_LAYOUT_BG_COLOR_TOP,
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "root",
    ref: root,
    class: _normalizeClass(["container", _unref(backgroundColorTypeTop)?.toLowerCase()]),
    style: _normalizeStyle(_unref(style))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _renderSlot(_ctx.$slots, "default")
    ])
  ], 6))
}
}

})